/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionParserStatus {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionParserStatus.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionParserStatus>): AppSecopsSbomVersionParserStatus {
        let obj = Object.assign(new AppSecopsSbomVersionParserStatus(), model);
        AppSecopsSbomVersionParserStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionParserStatus>): AppSecopsSbomVersionParserStatus {
        if (!model) return null;
        return AppSecopsSbomVersionParserStatus.newInstance(<AppSecopsSbomVersionParserStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionParserStatus) {
        if (!obj) return;

        models.AppSecopsSbomVersionParserStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionParserStatus): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionParserStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.time_taken === undefined) {
            this.time_taken = 0;
        }
    }

    /**
     * Parsing status of SBOM
     */
    status: models.SbomParsingStatus;

    /**
     * Parsing message of SBOM
     */
    message: string;

    /**
     * Time taken for parsing in seconds
     */
    time_taken: number;

}
